/**
 * Convert PROFILE.heartbeat_hourly map to FusionCharts timeseries rows.
 * Mirrors dataprotected-api api/heartbeat.py heartbeat_hourly_to_chart().
 */
export function heartbeatHourlyToChart(hourlyMap, days = 7) {
  if (!hourlyMap || typeof hourlyMap !== 'object' || Array.isArray(hourlyMap)) {
    return []
  }

  const endMs = Date.now()
  const startMs = endMs - days * 24 * 60 * 60 * 1000
  const rows = []

  for (const [hourKey, count] of Object.entries(hourlyMap)) {
    const hourMs = parseUtcHourKey(hourKey)
    if (hourMs == null || hourMs < startMs) continue
    rows.push([formatChartTime(hourMs), Number(count)])
  }

  rows.sort((a, b) => a[0].localeCompare(b[0]))
  return rows
}

function parseUtcHourKey(hourKey) {
  if (typeof hourKey !== 'string' || !hourKey) return null
  // DynamoDB keys are ISO UTC with offset; Date.parse handles both offset and Z forms.
  const ms = Date.parse(hourKey)
  return Number.isNaN(ms) ? null : ms
}

function formatChartTime(ms) {
  return new Date(ms).toISOString().slice(0, 19)
}

/**
 * Normalize ADMIN_GET_LATEST_HEARTBEATS responses (array of [time, count]).
 */
export function normalizeHeartbeatChartRows(data) {
  if (!Array.isArray(data)) return []
  return data
    .filter((row) => Array.isArray(row) && row.length >= 2)
    .map(([time, count]) => [String(time), Number(count)])
}
